import { DecimalPipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConfigurationService } from '../../services/configuration.service';
import { MarketService } from '../../services/market.service';
import { Currency } from '../../types/configuration.types';
import { PriceBase } from '../../types/product.types';

@Component({
	selector: 'cramo-price-display',
	standalone: true,
	templateUrl: './price-display.component.html',
})
export class PriceDisplayComponent {
	private readonly configurationService = inject(ConfigurationService);
	private readonly marketService = inject(MarketService);
	protected readonly featureToggles = toSignal(this.configurationService.featureToggles$, { requireSync: true });
	private decimalPipe = inject(DecimalPipe);

	// Either pass a price base type or a string
	public readonly price = input.required<PriceBase | number>();
	public readonly suffix = input('');

	protected currency: Currency = this.marketService.currentCurrency;
	protected isCurrencyPrefixed = this.currency === 'EUR';

	protected formattedPrice = computed(() => {
		const priceInput = this.price();
		let price: number;

		if (typeof priceInput === 'number') {
			price = priceInput;
		} else {
			const { inclVat, exclVat } = priceInput;
			price = this.featureToggles().price.isVatDefaultPrice ? inclVat : exclVat;
		}

		const formatedPrice = this.decimalPipe.transform(price, '1.2-2');

		if (this.isCurrencyPrefixed) {
			return `${currencyMap[this.currency]}${formatedPrice}${this.suffix()}`;
		} else {
			return `${formatedPrice}${currencyMap[this.currency]}${this.suffix()}`;
		}
	});
}

const currencyMap: Record<Currency, string> = {
	SEK: ' kr',
	NOK: ' kr',
	EUR: '€',
} as const;
